import script from "./FileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileCard.vue?vue&type=script&setup=true&lang=ts"

import "./FileCard.vue?vue&type=style&index=0&id=72d1b9e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d1b9e0"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBar,QSpace});qInstall(script, 'directives', {ClosePopup});
